import * as Sentry from "@sentry/react";
import { router } from "@/Router.tsx";
import packageJson from "../package.json";

const environment =
    import.meta.env.MODE === "dev"
        ? "development"
        : import.meta.env.MODE ||
          (import.meta.env.PROD ? "production" : "development");

Sentry.init({
    dsn: "https://0723b8fe8ac54d5daecd4c5f181cec45@glitchtip.swiftbyte.de/1",
    integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
    release: packageJson.version,
    environment,
    enabled: false, //import.meta.env.PROD,
});
